export default __webpack_public_path__ + "static/media/anxiety.0887145b.svg";